import { defineMessages } from 'react-intl';

const I18N_NAMESPACE = 'SupportPage';

export default defineMessages({
  headTitle: {
    id: `${I18N_NAMESPACE}.headTitle`,
    defaultMessage: 'Support',
  },

  pageTitle: {
    id: `${I18N_NAMESPACE}.pageTitle`,
    defaultMessage: 'Support',
  },
  pageDescriptionLine1: {
    id: `${I18N_NAMESPACE}.pageDescriptionLine1`,
    defaultMessage:
      "Give us some information, and we'll find the best solution for you.",
  },
  pageDescriptionLine2: {
    id: `${I18N_NAMESPACE}.pageDescriptionLine2`,
    defaultMessage:
      'Visit our FAQ page to find answers to common questions and concerns.',
  },
  loginToGetHelp: {
    id: `${I18N_NAMESPACE}.loginToGetHelp`,
    defaultMessage: `Log in to get help →`,
  },

  leaveAddressAndContactDetailsHelp: {
    id: `${I18N_NAMESPACE}.leaveAddressAndContactDetailsHelp`,
    defaultMessage: `Leave my address & contact details →`,
  },

  wordFaq: {
    id: `${I18N_NAMESPACE}.wordFaq`,
    defaultMessage: 'FAQ Page',
  },
  supportForCustomer: {
    id: `${I18N_NAMESPACE}.supportForCustomer`,
    defaultMessage: 'Support for customers',
  },
  supportForNonCustomer: {
    id: `${I18N_NAMESPACE}.supportForNonCustomer`,
    defaultMessage: 'Not a customer yet?',
  },
  customerCardDetail: {
    id: `${I18N_NAMESPACE}.customerCardDetail`,
    defaultMessage:
      'Got questions about your products, installation, or anything else? Our FAQs answer most questions. Still need help? Log in to MyPage and head to our support section for further assistance.',
  },
  nonCustomerCardDetail: {
    id: `${I18N_NAMESPACE}.nonCustomerCardDetail`,
    defaultMessage:
      'Visit {localeLink} and our {faqLink} page to learn more about all of our products and what to consider before purchasing. Leave your address and contact details if you have further questions, and our Technical Specialists will reach out to provide the answers you need.',
  },
});
